
import ".././styles/Rental.css";
import banquethallpic from ".././assets/banquethall.jpg";
import BanquetHall from "../components/BanquetHall.js";
import Boardroom from "../components/Boardroom.js";
import { Link } from "react-router-dom";
import React, { useState } from "react";
const  Rental = () => {
    const [active, setActive] = React.useState(1);
    const SetView = (active) => {
        setActive(active);
    };

    const ActiveView = () => {
        switch (active) {
            case 1:
                return <BanquetHall />;
            default:
                return <Boardroom />;
        }
    };
    return (
        <div>
            <div className="container">
                <div className="rental-banner-container">
                    <div className="rental-banner" id="banner">
                        <h1>Community Spaces</h1>
                    </div>
                </div>
                <div className="rental-selector">
                    {/* <button id="banquet-hall-button" onClick={() => SetView(1)} ><h3>Banquet Hall</h3></button>
                    <button id="boardroom-button" onClick={() => SetView(2)}><h3>Boardroom</h3></button> */}
                    <input type="radio" name="answer"id="banquet-button" onClick={() => {SetView(1)}} defaultChecked/> <label for="banquet-button"><h3>Banquet Hall</h3></label>
                    <input type="radio" name="answer"id="boardroom-button" onClick={() => SetView(2)}/><label for="boardroom-button"><h3>Boardroom</h3></label>
                </div>
                {ActiveView()}
            </div>

        </div>
    );
}

export default Rental;